import { useContext, useEffect, useState } from "react";
import { Context } from "../../Context/Context";
import { Link } from "react-router-dom";


const HeaderLogin = () => {

    const { json } = useContext(Context);

    const headerLoginContent = json?.headerLogin;
    const [smallScreen, setSmallScreen] = useState(window.innerWidth < 1200);

    const handleSetSmallScreen = () => {
        setSmallScreen(window.innerWidth < 1200);
    }

    useEffect(() => {
        window.addEventListener("resize", handleSetSmallScreen);

        return () => {
            window.removeEventListener("resize", handleSetSmallScreen);
        }
    }, []);

    return (
        <header className="header">
            <div className="header-desktop-one">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                            <a href="/" className="header-desktop-logo">
                            {smallScreen ? (
                                        <img src="/imgs/favicon.png" alt="..." />
                                    ) : (
                                        <img src="/imgs/wisercam logo.svg" alt="logo" />
                                    )}
                            </a>
                        </div>
                        <div className="d-flex align-items-center">
                            <Link to="/" className="btn-login">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M28.5002 16C28.5002 16.3978 28.3422 16.7794 28.0609 17.0607C27.7796 17.342 27.398 17.5 27.0002 17.5H8.62521L15.0652 23.9388C15.347 24.2206 15.5053 24.6027 15.5053 25.0013C15.5053 25.3998 15.347 25.782 15.0652 26.0638C14.7834 26.3456 14.4012 26.5039 14.0027 26.5039C13.6042 26.5039 13.222 26.3456 12.9402 26.0638L3.94021 17.0638C3.80037 16.9244 3.68941 16.7588 3.6137 16.5765C3.53799 16.3942 3.49902 16.1987 3.49902 16.0013C3.49902 15.8038 3.53799 15.6084 3.6137 15.426C3.68941 15.2437 3.80037 15.0781 3.94021 14.9388L12.9402 5.93876C13.0797 5.79923 13.2454 5.68855 13.4277 5.61304C13.61 5.53752 13.8054 5.49866 14.0027 5.49866C14.2 5.49866 14.3954 5.53752 14.5777 5.61304C14.76 5.68855 14.9257 5.79923 15.0652 5.93876C15.2047 6.07829 15.3154 6.24393 15.3909 6.42624C15.4664 6.60854 15.5053 6.80393 15.5053 7.00126C15.5053 7.19858 15.4664 7.39398 15.3909 7.57628C15.3154 7.75858 15.2047 7.92423 15.0652 8.06376L8.62521 14.5H27.0002C27.398 14.5 27.7796 14.658 28.0609 14.9393C28.3422 15.2207 28.5002 15.6022 28.5002 16Z" fill="white" />
                                </svg>
                                <span className="d-none d-lg-block">
                                    {headerLoginContent.btnBack}
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default HeaderLogin;